import { render, staticRenderFns } from "./Fieldset.vue?vue&type=template&id=52a6b06d&scoped=true&"
import script from "./Fieldset.vue?vue&type=script&lang=js&"
export * from "./Fieldset.vue?vue&type=script&lang=js&"
import style0 from "./Fieldset.vue?vue&type=style&index=0&id=52a6b06d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a6b06d",
  null
  
)

export default component.exports